export default __webpack_public_path__ + "images/Axial_View_of_Fetal_Bladder_dark.4a3f1e701a33423d739f992a7740a81e.png";